function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import { px2rem, padding, font } from '../../utils/helpers';
var InputLabel = styled.label(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      hasIcon = _ref.hasIcon,
      hasError = _ref.hasError;
  var colors = theme.colors,
      text = theme.text,
      input = theme.input;
  return _extends({
    position: 'absolute',
    top: 0,
    display: 'inline-block',
    width: '100%',
    margin: 0
  }, padding(_extends({}, input, {
    paddingRight: hasIcon ? input.paddingRight * 2 + input.icon.size : undefined
  })), font({
    fontFamily: !hasError ? text.shared.normal.fontFamily : text.shared.bold.fontFamily,
    fontWeight: !hasError ? text.shared.normal.fontWeight : text.shared.bold.fontWeight,
    fontSize: text.standard.xlarge.fontSize,
    lineHeight: text.standard.xlarge.lineHeight
  }), {
    color: !hasError ? colors[input.label["default"].color] : colors[input.label.error.color],
    transition: 'all 200ms',
    svg: {
      position: 'absolute',
      top: px2rem(input.paddingTop - (input.icon.size - text.standard.xlarge.lineHeight) / 2),
      right: px2rem(input.paddingRight),
      path: {
        fill: !hasError ? colors[input.label["default"].color] : '#000'
      },
      ':focus,:active': {
        outlineOffset: 6
      }
    }
  });
});
export default InputLabel;